import React, { useState } from 'react'
import {Upload, X} from 'lucide-react'
import { lumi } from '@/lib/lumi'

interface ProfilePhotoUploadProps {
  onSuccess: (imageUrl: string) => void
  onClose: () => void
}

export function ProfilePhotoUpload({ onSuccess, onClose }: ProfilePhotoUploadProps) {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    if (!file.type.startsWith('image/')) {
      setError('Por favor, selecione apenas arquivos de imagem')
      return
    }

    if (file.size > 10 * 1024 * 1024) {
      setError('Arquivo muito grande. Máximo 10MB')
      return
    }

    setError('')
    setUploading(true)

    try {
      const results = await lumi.tools.file.upload([file])
      console.log('Upload results:', results)
      
      if (results && results.length > 0 && results[0].fileUrl) {
        onSuccess(results[0].fileUrl)
        onClose()
      } else if (results && results.length > 0 && results[0].uploadError) {
        setError(results[0].uploadError)
      } else {
        setError('Erro ao fazer upload. Tente novamente.')
      }
    } catch (err: any) {
      console.error('Upload error:', err)
      const errorMessage = err?.data?.error || err?.message || 'Erro ao fazer upload. Tente novamente.'
      setError(errorMessage)
    } finally {
      setUploading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gradient-to-br from-[#2D1B4E] to-[#1a0f2e] border-2 border-[#D4AF37] rounded-3xl p-8 max-w-md w-full shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold text-white">Upload de Foto</h3>
          <button
            onClick={onClose}
            className="text-purple-300 hover:text-white transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <label className="block">
            <div className="border-2 border-dashed border-[#D4AF37]/50 rounded-2xl p-8 text-center cursor-pointer hover:border-[#D4AF37] transition-all">
              <Upload className="w-12 h-12 text-[#D4AF37] mx-auto mb-4" />
              <p className="text-purple-200 mb-2">
                {uploading ? 'Enviando...' : 'Clique para selecionar uma foto'}
              </p>
              <p className="text-sm text-purple-400">
                Formato retrato (4:5 ou 1:1) - Máx 10MB
              </p>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                disabled={uploading}
                className="hidden"
              />
            </div>
          </label>

          {error && (
            <div className="bg-red-900/20 border border-red-500/50 rounded-lg p-4">
              <p className="text-red-300 text-sm">{error}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
